import React from "react";
import { Table, Pagination } from "antd";
import { strings, perPage } from "../../helpers";

export default class PatientReferralView extends React.Component {
  render() {
    const {
      referralsList,
      isProcessing,
      showNewReferralAlert,
      goToDetailPage,
      toggleNotesModal,
      totalRecords,
      activePage,
      handlePageChange
    } = this.props;

    const columns = [
      {
        title: strings.referrals.serialNo,
        dataIndex: "",
        key: "unique_id",
        align: "left",
        render: (text, record, index) => (
          <div className="relative">
            {showNewReferralAlert && index === 0 ? (
              <div className="new-ticket-marker" />
            ) : (
              ""
            )}
            {`#${record.unique_id}`}
          </div>
        )
      },
      {
        title: strings.referrals.patient,
        key: "patient",
        align: "left",
        render: record => (
          <div>
            {
              record && record.referred_by_doctor ? 
              <div>
                <div className="first_line">{record.referred_by_doctor.name}</div>
                  <div>{`${record.referred_by_doctor.country_code}-${
                    record.referred_by_doctor.phone_number
                  }`}</div>
                  <div>{record.referred_by_doctor.speciality}</div>
              </div>: "--"
            }
            
          </div>
        )
      },
      {
        title: strings.referrals.referredBy,
        key: "referredBy",
        align: "left",
        render: record => (
          <div>
            {
              record && record.referred_by_doctor ? 
              <div>
                <div className="first_line">{record.referred_by_doctor.name}</div>
                  <div>{`${record.referred_by_doctor.country_code}-${
                    record.referred_by_doctor.phone_number
                  }`}</div>
                  <div>{record.referred_by_doctor.speciality}</div>
              </div> :
              "--"
            }
          </div>
        )
      },
      {
        title: strings.referrals.referredTo,
        key: "referredTo",
        align: "left",
        render: record => (
          <div>
            {
              record && record.referred_to_doctor ? 
              <div>
                <div className="first_line">{record.referred_to_doctor.name}</div>
                <div>
                  {`${record.referred_to_doctor.country_code}-${
                    record.referred_to_doctor.phone_number
                  }`}
                </div>
                <div>{record.referred_to_doctor.speciality}</div>
              </div> :
              "--"
            }
          </div>
        )
      },
      {
        title: strings.referrals.appointmentStatus,
        key: "appointment_status",
        align: "left",
        render: record => (
          <div>
            {record.appointment_count > 0 ? (
              <span className="text-upper booket-appt-marker">
                {strings.dashboard.booked}
              </span>
            ) : (
              <span className="text-upper unbooked-appt-marker">
                {strings.dashboard.notBooked}
              </span>
            )}
          </div>
        )
      },
      {
        title: "",
        key: "add_to_queue",
        align: "left",
        render: record => (
          <a href="javascript:;" onClick={() => goToDetailPage(record.id)}>
            {strings.referrals.addToQueue}
          </a>
        )
      },
      {
        title: "",
        key: "view_notes",
        align: "left",
        render: record => (
          <a href="javascript:;" onClick={() => toggleNotesModal(record.notes)}>
            {strings.referrals.viewNotes}
          </a>
        )
      }
    ];

    return (
      <div className="content-container">
        <div className="with-box-shadow">
          <div className="kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={referralsList}
              loading={isProcessing}
              pagination={false}
              rowKey={record => record.unique_id}
            />
            {totalRecords && (
              <div className="pagination-wrapper">
                <div className="total-results-wrap">
                  <span className="result-count">{totalRecords}</span>
                  {totalRecords > 1 ? strings.results : strings.result}
                </div>
                {totalRecords > 10 && (
                  <Pagination
                    current={activePage}
                    total={totalRecords}
                    defaultCurrent={activePage}
                    pageSize={perPage}
                    onChange={handlePageChange}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
